module.exports = __webpack_public_path__ + "img/14.33a3c3f8.jpg";